
import { Component, Prop, Vue } from 'vue-property-decorator';
import SidebarCard from '@/components/global/sidebar/SidebarCard.vue';
import CMSUserRepository from '@/repositories/CMSUserRepository';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';

@Component({
    name: 'ClientViewSidebarDefaultCommercialist',
    components: {
        SidebarCard,
    },
})
export default class ClientViewSidebarDefaultCommercialist extends Vue {
    @Prop({ required: true }) private value!: string;

    private editModeOn = false;
    private assignedUser: string = '';
    private cachedUser: string = '';

    private get userName() {
        if (this.value && !this.assignedUser) {
            this.assignedUser = this.value;
        }

        return CMSUserRepository.getSalesmanById(this.value)?.name ?? '';
    }

    private get salesmen() {
        return CMSUserRepository.getAllSalesmen();
    }

    private onEdit() {
        this.cachedUser = this.assignedUser;
        this.editModeOn = true;
    }

    private onCancel() {
        this.assignedUser = this.cachedUser;
        this.editModeOn = false;
    }

    private handleChange(id: string) {
        this.assignedUser = id;
    }

    private setLocalData(): void {
        this.editModeOn = false;

        this.$emit('input', this.assignedUser);
    }

    private beforeDestroy() {
        EventBus.$off(EventBusEvents.updateClientCachedData, this.setLocalData);
    }

    private mounted() {
        EventBus.$on(EventBusEvents.updateClientCachedData, this.setLocalData);
    }
}
